module.exports = __webpack_public_path__ + "img/lfcx2.b1129002.jpg";